import React from 'react'
import {
  FormDashboardLabel as Label,
  User,
} from '../../../components'
import Select from 'react-select'

const UserAdder = ({label}) => {
  const [isAdding, setIsAdding] = React.useState(false)
  return (
    <div>
      {
        !isAdding &&
        <p className="link" onClick={() => setIsAdding(true)}>{label}</p>
      }
      {
        isAdding &&
        <Select
          options={[{value: 'placeholder', label: 'Placeholder'}]}
          placeholder="Choose"
          onChange={() => setIsAdding(false)}
          className="text-sm"
        />
      }
    </div>
  )
}

const SidebarOfficer = () => {
  return (
    <div>
      <Label className="mb-3">Officer</Label>
      {/* <p className="link">Choose officer</p> */}
      <div className="flex items-center justify-between mb-3">
        <User small name="Jawad Mudghofar"/>
        <p className="text-xs text-gray-999 underline cursor-pointer">Delete</p>
      </div>
      <UserAdder label="+ Add new officer"/>
    </div>
  )
}

export { SidebarOfficer }